<template>
  <div class="select">
    <div class="form-group text-left" :class="{ 'mb-0': !hasMarginBottom }">
      <a-Label v-if="label">{{ label }}</a-Label>
      <select
        v-bind="$attrs"
        class="form-control"
        :class="getClass"
        @change="updateValue"
        :name="nameOrLabel"
        :data-vv-as="label"
        :disabled="disabled"
        v-validate="hlGetValidationRule()"
      >
        <template v-if="placeholder">
          <option
            v-if="typeof placeholderValue !== undefined"
            :value="placeholderValue"
            :disabled="placeholderDisabled"
          >
            {{ placeholder }}
          </option>
          <option v-else :disabled="placeholderDisabled">
            {{ placeholder }}
          </option>
        </template>
        <option :value="option.value" v-for="(option, key) in options" :key="key" :selected="value === option.value">
          {{ option.name }}
        </option>
      </select>

      <hl-ErrorMessage v-if="error || hlGetValidationError()" :errorVariant="errorVariant"
        >{{ error ? error : hlGetValidationError() }}
      </hl-ErrorMessage>
    </div>
  </div>
</template>

<script>
import ErrorMessage from '@modules/husleie-framework/src/components/text/ErrorMessage.vue';
import hlValidation from '@modules/husleie-framework/src/mixins/hlValidation';
import Label from '@modules/design-system/components/atoms/labels/Label.vue';

export default {
  components: {
    'hl-ErrorMessage': ErrorMessage,
    'a-Label': Label,
  },
  inheritAttrs: false,
  mixins: [hlValidation],

  name: 'selectMenu',
  props: {
    options: Array,
    name: {
      type: String,
    },
    error: {
      type: String,
      required: false,
    },
    errorVariant: {
      type: String,
      required: false,
      default: 'danger',
    },
    label: {
      type: String,
    },
    hasMarginBottom: {
      type: Boolean,
      default: true,
    },
    placeholder: String,
    placeholderValue: String,
    placeholderDisabled: Boolean,
    size: {
      type: String,
      default: 'lg',
    },
    value: [String, Number],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
  },
  computed: {
    nameOrLabel() {
      if (this.name) return this.name;

      if (this.label) return encodeURIComponent(this.label).toLowerCase();

      return 'placeholder' + Math.round(Math.random() * 100000);
    },

    getClass() {
      const classes = [];
      if (this.size === 'sm') {
        classes.push('select-sm');
      }

      if (this.error && this.errorVariant !== 'warning') {
        classes.push('is-invalid');
      }

      if (this.error && this.errorVariant === 'warning') {
        classes.push('is-warning');
      }

      if (this.disabled) {
        classes.push('disabled');
      }

      return classes;
    },
  },
};
</script>

<style scoped lang="scss">
.form-control.is-warning {
  border-color: $warning;
}

.select {
  label {
    font-size: 0.8em;
    color: $husleie-text-light;
    vertical-align: top;
  }
}

.select-sm {
  height: 32px;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.disabled {
  -webkit-appearance: none;
}
</style>
